module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFR.59d7d822.ttf";